import 'core-js/proposals/reflect-metadata';

import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Plugins
import "./plugins/buefy";
import "./plugins/fontawesome";
import "./plugins/date";

// SASS
import "./assets/branding/massif-styles.scss";

Vue.config.productionTip = false

const vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

(window as any).vue = vue;
